module.exports = __webpack_public_path__ + "static/img/lantu.6651d26.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lantu.jpg
// module id = yCsu
// module chunks = 1